import { render, staticRenderFns } from "./PostCreationFormModal.vue?vue&type=template&id=54252e74&scoped=true"
import script from "./PostCreationFormModal.vue?vue&type=script&lang=js"
export * from "./PostCreationFormModal.vue?vue&type=script&lang=js"
import style0 from "./PostCreationFormModal.vue?vue&type=style&index=0&id=54252e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54252e74",
  null
  
)

export default component.exports